module.exports = __webpack_public_path__ + "media/images/icon_likelist-b7572dcba236d9ec46a1a6c922daac01.svg";